import SessionStorageKeys from '../constants/sessionStorageKeys';

export const isSessionStorageAccess = () => {
  try {
    return !!(window && window.sessionStorage);
  } catch (error) {
    return false;
  }
}

export const getXAuthToken = () => {
  return isSessionStorageAccess() && sessionStorage.getItem(SessionStorageKeys.X_AUTH_TOKEN);
};

export const setXAuthTokenInSessionStorage = (data) => {
  isSessionStorageAccess() && sessionStorage.setItem(SessionStorageKeys.X_AUTH_TOKEN, data);
};

export const getTransactionInfo = () => {
  return isSessionStorageAccess() && JSON.parse(window.sessionStorage.getItem(SessionStorageKeys.USER_DATA) || null) ;
};

export const setTransactionInfo = (data) => {
  isSessionStorageAccess() && window.sessionStorage.setItem(SessionStorageKeys.USER_DATA, JSON.stringify(data));
};

export const updateTransactionInfo = data => {
  const currentTransactionInfo = getTransactionInfo();
  isSessionStorageAccess() && window.sessionStorage.setItem(SessionStorageKeys.USER_DATA, JSON.stringify({...currentTransactionInfo,...data}))
}

export const removeTransactionInfoAndAuthToken = () => {
  isSessionStorageAccess() && window.sessionStorage.removeItem(SessionStorageKeys.USER_DATA);
  isSessionStorageAccess() && window.sessionStorage.removeItem(SessionStorageKeys.X_AUTH_TOKEN);
  isSessionStorageAccess() && window.sessionStorage.removeItem(SessionStorageKeys.TRACEPARENT);
  isSessionStorageAccess() && window.sessionStorage.removeItem(SessionStorageKeys.LANGUAGE);
};

export const setTraceParentInSessionStorage = (data) => {
  isSessionStorageAccess() && sessionStorage.setItem(SessionStorageKeys.TRACEPARENT, data);
};

export const getTraceParent = () => {
  return isSessionStorageAccess() && sessionStorage.getItem(SessionStorageKeys.TRACEPARENT);
};

export const getLanguage = () => {
  return isSessionStorageAccess() && sessionStorage.getItem(SessionStorageKeys.LANGUAGE);
};

export const setLanguageInSessionStorage = (data) => {
  isSessionStorageAccess() && sessionStorage.setItem(SessionStorageKeys.LANGUAGE, data);
};